import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
// import { auth } from '../../helpers/Firebase';
import {
    LOGIN_USER,
    REGISTER_USER,
    LOGOUT_USER,
    FORGOT_PASSWORD,
    RESET_PASSWORD,
} from '../actions';

import {
    loginUserSuccess,
    loginUserError,
    registerUserSuccess,
    registerUserError,
    forgotPasswordSuccess,
    forgotPasswordError,
    resetPasswordSuccess,
    resetPasswordError
} from './actions';

import { INIT_STATE as authUser } from './reducer';

import { getLogoutUrl } from '../../config/auth';
import { performLogout } from '../../utils/authUtils';

// export function* watchLoginUser() {
//     yield takeEvery(LOGIN_USER, loginWithEmailPassword);
// }

const loginWithEmailPasswordAsync = async (email, password) => {
    const { baseURL, clientID, clientSecret } = authUser;
    return await fetch(`${baseURL}/oauth/login`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            user_id: email,
            password,
            client_id: clientID,
            client_secret: clientSecret
        })
    })
    .then( response => response.json() )
    .then( response => response )
    .catch( error => error );
    
    // return await auth.signInWithEmailAndPassword(email, password)
    //     .then(authUser => authUser)
    //     .catch(error => error);
}



function* loginWithEmailPassword({ payload }) {
    const { email, password } = payload.user;
    const { history } = payload;
    try {
        const loginUser = yield call(loginWithEmailPasswordAsync, email, password);
        if (!loginUser.message) {
            localStorage.setItem('token', loginUser.access_token);
            localStorage.setItem('user', JSON.stringify(loginUser.user));
            yield put(loginUserSuccess(loginUser));
            history.push('/');
        } else {
            yield put(loginUserError(loginUser.message));
        }
    } catch (error) {
        yield put(loginUserError(error));

    }
}


// export function* watchRegisterUser() {
//     yield takeEvery(REGISTER_USER, registerWithEmailPassword);
// }

// const registerWithEmailPasswordAsync = async (email, password) =>
//     await auth.createUserWithEmailAndPassword(email, password)
//         .then(authUser => authUser)
//         .catch(error => error);

function* registerWithEmailPassword({ payload }) {
    const { email, password } = payload.user;
    const { history } = payload
    try {
        // const registerUser = yield call(registerWithEmailPasswordAsync, email, password);
        // if (!registerUser.message) {
        //     localStorage.setItem('user_id', registerUser.user.uid);
        //     yield put(registerUserSuccess(registerUser));
        //     history.push('/')
        // } else {
        //     yield put(registerUserError(registerUser.message));

        // }
    } catch (error) {
        yield put(registerUserError(error));
    }
}



export function* watchLogoutUser() {
    yield takeEvery(LOGOUT_USER, logout);
}

// Simple synchronous logout function
function* logout() {
    try {
        // Use the shared logout function
        yield call(performLogout);
    } catch (error) {
        console.error('Error during logout:', error);
        // Fallback direct redirect
        window.location.href = getLogoutUrl();
    }
}

// export function* watchForgotPassword() {
//     yield takeEvery(FORGOT_PASSWORD, forgotPassword);
// }

const forgotPasswordAsync = async (email) => {

  
    const { baseURL, clientID, clientSecret } = authUser;
    let status = 200;
    const request = await fetch(`${baseURL}/password/email`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            user_id: email,
            client_id: clientID,
            client_secret: clientSecret
        })
    })
    .then( response => {
        status = response.status;
        return response.json();
    })
    .then( response => response )
    .catch( error => error );


    return {
        request,
        status
    };


    // return await auth.sendPasswordResetEmail(email)
    //     .then(user => user)
    //     .catch(error => error);
}

function* forgotPassword({ payload }) {
    const { email } = payload.forgotUserMail;
    try {
        const forgotPasswordStatus = yield call(forgotPasswordAsync, email);
        if (forgotPasswordStatus.status === 200) {
            yield put(forgotPasswordSuccess("success"));
        } else {
            yield put(forgotPasswordError(forgotPasswordStatus.request.message));
        }
    } catch (error) {
        yield put(forgotPasswordError(error));

    }
}

// export function* watchResetPassword() {
//     yield takeEvery(RESET_PASSWORD, resetPassword);
// }

// const resetPasswordAsync = async (resetPasswordCode, newPassword) => {
//     return await auth.confirmPasswordReset(resetPasswordCode, newPassword)
//         .then(user => user)
//         .catch(error => error);
// }

function* resetPassword({ payload }) {
    const { newPassword, resetPasswordCode } = payload;
    try {
        // const resetPasswordStatus = yield call(resetPasswordAsync, resetPasswordCode, newPassword);
        // if (!resetPasswordStatus) {
        //     yield put(resetPasswordSuccess("success"));
        // } else {
        //     yield put(resetPasswordError(resetPasswordStatus.message));
        // }
    } catch (error) {
        yield put(resetPasswordError(error));

    }
}

export default function* rootSaga() {
    yield all([
        // fork(watchLoginUser),
        // fork(watchRegisterUser),
        fork(watchLogoutUser),
        // fork(watchForgotPassword),
        // fork(watchResetPassword)
    ]);
}